import React, { useEffect } from 'react';

const MetaPixelWrapper = ({ pixelId, children }) => {
  useEffect(() => {
    // Initialize Facebook Pixel
    // Using proper function declaration syntax to avoid parsing issues
    const initFbPixel = () => {
      if (window.fbq) return;
      
      window.fbq = function() {
        window.fbq.callMethod ? 
          window.fbq.callMethod.apply(window.fbq, arguments) : 
          window.fbq.queue.push(arguments);
      };
      
      if (!window._fbq) window._fbq = window.fbq;
      
      window.fbq.push = window.fbq;
      window.fbq.loaded = true;
      window.fbq.version = '2.0';
      window.fbq.queue = [];
      
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      
      const firstScript = document.getElementsByTagName('script')[0];
      firstScript.parentNode.insertBefore(script, firstScript);
    };

    // Run the initialization function
    initFbPixel();
    
    // Initialize with your pixel ID
    window.fbq('init', pixelId);
    window.fbq('track', 'PageView');
    
    // Add the noscript pixel image (as a runtime DOM manipulation)
    const noscriptId = 'fb-noscript-pixel';
    if (!document.getElementById(noscriptId)) {
      const noscript = document.createElement('noscript');
      noscript.id = noscriptId;
      
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`;
      
      noscript.appendChild(img);
      document.body.appendChild(noscript);
    }
    
    // Return cleanup function
    return () => {
      const noscriptElement = document.getElementById(noscriptId);
      if (noscriptElement) {
        noscriptElement.remove();
      }
    };
  }, [pixelId]); // Only re-run if pixelId changes

  // Simply render children components
  return <>{children}</>;
};

export default MetaPixelWrapper;